export default __webpack_public_path__ + "static/media/demos.63b09428.svg";